// extracted by mini-css-extract-plugin
export var button = "index-module--button--2ABrZ";